module.exports = __webpack_public_path__ + "static/img/lunbo3.4584427.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/desktop/lunbo3.jpg
// module id = yGIk
// module chunks = 15